var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c(
            "div",
            { staticClass: "page-name", attrs: { id: "benefitHeader" } },
            [_vm._v("\n                Edit User\n            ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "changeProfile" } }, [
            _c("div", { staticClass: "forms-container" }, [
              _c(
                "div",
                { staticClass: "row no-margin" },
                [
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.firstName,
                              expression: "firstName"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "firstName",
                            placeholder: "First Name",
                            maxlength: "190"
                          },
                          domProps: { value: _vm.firstName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.firstName = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.frontendErrors.firstName))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.lastName,
                              expression: "lastName"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "lastName",
                            placeholder: "Last Name",
                            maxlength: "190"
                          },
                          domProps: { value: _vm.lastName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.lastName = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.frontendErrors.lastName))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "email",
                            placeholder: "Email",
                            maxlength: "190"
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.frontendErrors.email))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c(
                        "span",
                        {
                          staticClass: "form-control",
                          model: {
                            value: _vm.username,
                            callback: function($$v) {
                              _vm.username = $$v
                            },
                            expression: "username"
                          }
                        },
                        [_vm._v(_vm._s(_vm.username))]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              name: "reportTo",
                              id: "reportTo",
                              label: "text",
                              filterable: false,
                              options: _vm.reportToArr,
                              placeholder: "Select User"
                            },
                            on: {
                              change: _vm.changedValue,
                              input: function($event) {
                                return _vm.changedValueUser()
                              },
                              search: _vm.onSearchUser
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("div", { staticClass: "d-center" }, [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(option.text) +
                                          "\n                                            "
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "selected-option",
                                fn: function(option) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "selected d-center" },
                                      [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(option.text) +
                                            "\n                                            "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.reportTo,
                              callback: function($$v) {
                                _vm.reportTo = $$v
                              },
                              expression: "reportTo"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(
                                "\n                                            Search User...\n                                        "
                              )
                            ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.frontendErrors.reportToError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              name: "locationId",
                              id: "locationId",
                              label: "text",
                              filterable: false,
                              options: _vm.locationArr,
                              placeholder: "Select State"
                            },
                            on: {
                              change: _vm.changedValue,
                              input: function($event) {
                                return _vm.changedValueLocation()
                              },
                              search: _vm.onSearchLocation
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("div", { staticClass: "d-center" }, [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(option.text) +
                                          "\n                                        "
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "selected-option",
                                fn: function(option) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "selected d-center" },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(option.text) +
                                            "\n                                        "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.locationId,
                              callback: function($$v) {
                                _vm.locationId = $$v
                              },
                              expression: "locationId"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(
                                "\n                                        Search State...\n                                    "
                              )
                            ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.frontendErrors.locationError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(6),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("v-select", {
                          attrs: {
                            name: "siteId",
                            id: "siteId",
                            label: "text",
                            options: _vm.siteArr,
                            searchable: false,
                            filterable: false,
                            placeholder: "Select Home Location"
                          },
                          on: {
                            input: function($event) {
                              return _vm.changedValueSite()
                            }
                          },
                          model: {
                            value: _vm.siteId,
                            callback: function($$v) {
                              _vm.siteId = $$v
                            },
                            expression: "siteId"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.siteError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("multiselect", {
                          staticClass: "form-control",
                          attrs: {
                            options: _vm.siteArr,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            placeholder: "Select Other Location",
                            label: "text",
                            "track-by": "text",
                            "preselect-first": true
                          },
                          on: {
                            input: function($event) {
                              _vm.otherSiteError = ""
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "option",
                              fn: function(props) {
                                return [
                                  _vm.appliedStatusFilter.includes(
                                    props.option.value
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "multiple_select_item selected_multiple_item"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(props.option.text))
                                          ])
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "multiple_select_item" },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(props.option.text))
                                          ])
                                        ]
                                      )
                                ]
                              }
                            },
                            {
                              key: "selection",
                              fn: function(ref) {
                                var values = ref.values
                                var search = ref.search
                                var isOpen = ref.isOpen
                                return [
                                  values.length > 1 && !isOpen
                                    ? _c(
                                        "span",
                                        { staticClass: "multiselect__single" },
                                        [
                                          _vm._v(
                                            _vm._s(values.length) + " selected"
                                          )
                                        ]
                                      )
                                    : values.length > 0 && values.length <= 1
                                    ? _c(
                                        "span",
                                        { staticClass: "multiselect__single" },
                                        [_vm._v(_vm._s(values[0].text))]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.otherSiteId,
                            callback: function($$v) {
                              _vm.otherSiteId = $$v
                            },
                            expression: "otherSiteId"
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.otherSiteError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("v-select", {
                          attrs: {
                            name: "departmentId",
                            id: "departmentId",
                            label: "text",
                            options: _vm.departmentArr,
                            searchable: false,
                            filterable: false,
                            placeholder: "Select Department"
                          },
                          on: {
                            input: function($event) {
                              return _vm.changedValueDepartment()
                            }
                          },
                          model: {
                            value: _vm.departmentId,
                            callback: function($$v) {
                              _vm.departmentId = $$v
                            },
                            expression: "departmentId"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.departmentError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "phone",
                            placeholder: "Phone",
                            maxlength: "190"
                          },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phone = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.frontendErrors.phoneError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(10),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.post,
                              expression: "post"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "post",
                            placeholder: "Post",
                            maxlength: "190"
                          },
                          domProps: { value: _vm.post },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.post = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.frontendErrors.postError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.teamDesignation,
                              expression: "teamDesignation"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "teamDesignation",
                            placeholder: "Team Designation",
                            maxlength: "190"
                          },
                          domProps: { value: _vm.teamDesignation },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.teamDesignation = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(
                            _vm._s(_vm.frontendErrors.teamDesignationError)
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(12),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bio,
                            expression: "bio"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "bio",
                          placeholder: "Bio",
                          maxlength: "190"
                        },
                        domProps: { value: _vm.bio },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bio = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.loginId != _vm.user_id
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _vm._m(13),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 paddingleft0" },
                          [
                            _c("v-select", {
                              attrs: {
                                name: "roleId",
                                id: "roleId",
                                label: "text",
                                searchable: false,
                                filterable: false,
                                options: _vm.roleArr,
                                placeholder: "Select Role"
                              },
                              on: {
                                input: function($event) {
                                  return _vm.changedRole()
                                }
                              },
                              model: {
                                value: _vm.roleId,
                                callback: function($$v) {
                                  _vm.roleId = $$v
                                },
                                expression: "roleId"
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.frontendErrors.roleId))
                            ])
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(14),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.quote,
                            expression: "quote"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "quote",
                          placeholder: "Quote"
                        },
                        domProps: { value: _vm.quote },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.quote = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(15),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.quoteName,
                            expression: "quoteName"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "quoteName",
                          placeholder: "Quote Name"
                        },
                        domProps: { value: _vm.quoteName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.quoteName = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 forms-block" }, [
                    _vm._m(16),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("tinymce", {
                          ref: "tm",
                          attrs: {
                            plugins: [
                              "advlist autolink lists link image charmap print preview hr anchor pagebreak",
                              "searchreplace wordcount visualblocks visualchars code fullscreen",
                              "insertdatetime media nonbreaking save table contextmenu directionality",
                              "template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample"
                            ],
                            id: "description"
                          },
                          model: {
                            value: _vm.description,
                            callback: function($$v) {
                              _vm.description = $$v
                            },
                            expression: "description"
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.frontendErrors.descriptionError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.loginId != _vm.user_id || _vm.roleIdCheck == 0
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _c("div", { staticClass: "col-12 paddingleft0" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-label",
                              attrs: { for: "allow_social_calendar" }
                            },
                            [_vm._v("Allow Social Media Calendar :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allowSocialCalendar,
                                expression: "allowSocialCalendar"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "allow_social_calendar",
                              name: "allow_social_calendar"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.allowSocialCalendar)
                                ? _vm._i(_vm.allowSocialCalendar, null) > -1
                                : _vm.allowSocialCalendar
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.allowSocialCalendar,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.allowSocialCalendar = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.allowSocialCalendar = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.allowSocialCalendar = $$c
                                }
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.allowSocialCalendar
                    ? [
                        _vm.loginId != _vm.user_id || _vm.roleIdCheck == 0
                          ? _c("div", { staticClass: "col-6 forms-block" }, [
                              _c(
                                "div",
                                { staticClass: "col-12 paddingleft0" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-label",
                                      attrs: {
                                        for: "allow_review_social_media"
                                      }
                                    },
                                    [_vm._v("Connect & Review Social Media :")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.allowReviewSocialMedia,
                                        expression: "allowReviewSocialMedia"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "allow_review_social_media",
                                      name: "allow_review_social_media"
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.allowReviewSocialMedia
                                      )
                                        ? _vm._i(
                                            _vm.allowReviewSocialMedia,
                                            null
                                          ) > -1
                                        : _vm.allowReviewSocialMedia
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.allowReviewSocialMedia,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.allowReviewSocialMedia = $$a.concat(
                                                [$$v]
                                              ))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.allowReviewSocialMedia = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.allowReviewSocialMedia = $$c
                                        }
                                      }
                                    }
                                  })
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginId != _vm.user_id || _vm.roleIdCheck == 0
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _c("div", { staticClass: "col-12 paddingleft0" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-label",
                              attrs: { for: "allow_contact_extension" }
                            },
                            [_vm._v("Allow Contact Extension Directory :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allowContactExtension,
                                expression: "allowContactExtension"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "allow_contact_extension",
                              name: "allow_contact_extension"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.allowContactExtension)
                                ? _vm._i(_vm.allowContactExtension, null) > -1
                                : _vm.allowContactExtension
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.allowContactExtension,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.allowContactExtension = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.allowContactExtension = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.allowContactExtension = $$c
                                }
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginId != _vm.user_id || _vm.roleIdCheck == 0
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _c("div", { staticClass: "col-12 paddingleft0" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-label",
                              attrs: { for: "add_location_departments" }
                            },
                            [_vm._v("Can Manage Contact Extension Locations :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.addLocationDepartments,
                                expression: "addLocationDepartments"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "add_location_departments",
                              name: "add_location_departments"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.addLocationDepartments)
                                ? _vm._i(_vm.addLocationDepartments, null) > -1
                                : _vm.addLocationDepartments
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.addLocationDepartments,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.addLocationDepartments = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.addLocationDepartments = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.addLocationDepartments = $$c
                                }
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginId != _vm.user_id || _vm.roleIdCheck == 0
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _c("div", { staticClass: "col-12 paddingleft0" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-label",
                              attrs: { for: "allow_user_management" }
                            },
                            [_vm._v("Allow User Management Module :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allowUserManamentModule,
                                expression: "allowUserManamentModule"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "allow_user_management",
                              name: "allow_user_management"
                            },
                            domProps: {
                              checked: Array.isArray(
                                _vm.allowUserManamentModule
                              )
                                ? _vm._i(_vm.allowUserManamentModule, null) > -1
                                : _vm.allowUserManamentModule
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.allowUserManamentModule,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.allowUserManamentModule = $$a.concat(
                                        [$$v]
                                      ))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.allowUserManamentModule = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.allowUserManamentModule = $$c
                                }
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginId != _vm.user_id || _vm.roleIdCheck == 0
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _c("div", { staticClass: "col-12 paddingleft0" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-label",
                              attrs: { for: "allow_forum_module" }
                            },
                            [_vm._v("Allow Forum Module :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allowForumModule,
                                expression: "allowForumModule"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "allow_forum_module",
                              name: "allow_forum_module"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.allowForumModule)
                                ? _vm._i(_vm.allowForumModule, null) > -1
                                : _vm.allowForumModule
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.allowForumModule,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.allowForumModule = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.allowForumModule = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.allowForumModule = $$c
                                }
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginId != _vm.user_id || _vm.roleIdCheck == 0
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _c("div", { staticClass: "col-12 paddingleft0" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-label",
                              attrs: { for: "allow_manager_tool_box" }
                            },
                            [_vm._v("Allow Manager Tool Box :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allowManagerToolBox,
                                expression: "allowManagerToolBox"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "allow_manager_tool_box",
                              name: "allow_manager_tool_box"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.allowManagerToolBox)
                                ? _vm._i(_vm.allowManagerToolBox, null) > -1
                                : _vm.allowManagerToolBox
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.allowManagerToolBox,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.allowManagerToolBox = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.allowManagerToolBox = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.allowManagerToolBox = $$c
                                }
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginId != _vm.user_id || _vm.roleIdCheck == 0
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _c("div", { staticClass: "col-12 paddingleft0" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-label",
                              attrs: { for: "show_user_manager_directory" }
                            },
                            [_vm._v("Show User in Manager Directory :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showUsrManagerDirectory,
                                expression: "showUsrManagerDirectory"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "show_user_manager_directory",
                              name: "show_user_manager_directory"
                            },
                            domProps: {
                              checked: Array.isArray(
                                _vm.showUsrManagerDirectory
                              )
                                ? _vm._i(_vm.showUsrManagerDirectory, null) > -1
                                : _vm.showUsrManagerDirectory
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.showUsrManagerDirectory,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showUsrManagerDirectory = $$a.concat(
                                        [$$v]
                                      ))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showUsrManagerDirectory = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showUsrManagerDirectory = $$c
                                }
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginId != _vm.user_id || _vm.roleIdCheck == 0
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _c("div", { staticClass: "col-12 paddingleft0" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-label",
                              attrs: { for: "manage_smc_events" }
                            },
                            [_vm._v("Manage Social Media Calendar Event :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.manageSMCEvent,
                                expression: "manageSMCEvent"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "manage_smc_events",
                              name: "manage_smc_events"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.manageSMCEvent)
                                ? _vm._i(_vm.manageSMCEvent, null) > -1
                                : _vm.manageSMCEvent
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.manageSMCEvent,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.manageSMCEvent = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.manageSMCEvent = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.manageSMCEvent = $$c
                                }
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginId != _vm.user_id || _vm.roleIdCheck == 0
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _c("div", { staticClass: "col-12 paddingleft0" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-label",
                              attrs: { for: "can_access_manager_directory" }
                            },
                            [_vm._v("Can Access Manager Directory :")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.canAccessManagerDirectory,
                                expression: "canAccessManagerDirectory"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "can_access_manager_directory",
                              name: "can_access_manager_directory"
                            },
                            domProps: {
                              checked: Array.isArray(
                                _vm.canAccessManagerDirectory
                              )
                                ? _vm._i(_vm.canAccessManagerDirectory, null) >
                                  -1
                                : _vm.canAccessManagerDirectory
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.canAccessManagerDirectory,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.canAccessManagerDirectory = $$a.concat(
                                        [$$v]
                                      ))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.canAccessManagerDirectory = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.canAccessManagerDirectory = $$c
                                }
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-12 forms-block",
                      attrs: { id: "pro_pic_id" }
                    },
                    [
                      _vm._m(17),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 paddingleft0" },
                        [
                          _c("vue-dropzone", {
                            ref: "dropzone",
                            attrs: {
                              id: "drop1",
                              options: _vm.dropzoneOptions,
                              destroyDropzone: false,
                              headers: _vm.dropzoneOptions.headers,
                              name: "file"
                            },
                            on: {
                              "vdropzone-removed-file": _vm.removedSelectedFile,
                              "vdropzone-success": _vm.vfileSuccess
                            }
                          }),
                          _vm._v(" "),
                          _c("font", { staticClass: "text-danger" }, [
                            _c("strong", {
                              staticClass: "error text-danger",
                              attrs: { id: "uploadErrorMsg" }
                            })
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 paddingleft0" },
                      [
                        _c("vue-croppie", {
                          ref: "croppieRef",
                          attrs: {
                            id: "vuecrop",
                            viewport: {
                              width: 276,
                              height: 312,
                              type: "square"
                            },
                            boundary: { width: 286, height: 322 },
                            enableResize: false
                          },
                          on: { result: _vm.result, update: _vm.update }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 paddingleft0" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn-croppie",
                            attrs: {
                              id: "rotateAnti",
                              type: "button",
                              title: "Rotate Left"
                            },
                            on: {
                              click: function($event) {
                                return _vm.rotate(-90)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-repeat",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-croppie",
                            attrs: {
                              id: "rotateClock",
                              type: "button",
                              title: "Rotate Right"
                            },
                            on: {
                              click: function($event) {
                                return _vm.rotate(90)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-undo",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-croppie",
                            attrs: {
                              id: "crop",
                              type: "button",
                              title: "Crop"
                            },
                            on: {
                              click: function($event) {
                                return _vm.crop()
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-crop",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("img", {
                          attrs: { src: _vm.cropped, width: "200" }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.cropError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "col-12 paddingleft0" }, [
                      _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit", value: "Save", id: "save" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.changeProfile()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: {
                          type: "button",
                          value: "Change Password",
                          id: "change_password",
                          "data-toggle": "modal",
                          "data-target": "#changePassword"
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modal fade",
                      attrs: { id: "changePassword", role: "dialog" }
                    },
                    [
                      _c("div", { staticClass: "modal-dialog" }, [
                        _c("div", { staticClass: "modal-content" }, [
                          _vm._m(18),
                          _vm._v(" "),
                          _c("div", { staticClass: "modal-body" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "newPassword" } },
                                    [_vm._v("New Password")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.newPassword,
                                        expression: "newPassword"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id: "newPassword",
                                      type: "text",
                                      placeholder: "",
                                      name: "newPassword",
                                      maxlength: "190"
                                    },
                                    domProps: { value: _vm.newPassword },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.newPassword = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("font", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      _vm._s(_vm.frontendErrors.newPassword)
                                    )
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-12" }, [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "cpassword" } }, [
                                    _vm._v("Confirm Password")
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.cpassword,
                                        expression: "cpassword"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id: "cpassword",
                                      type: "text",
                                      placeholder: "",
                                      name: "cpassword",
                                      maxlength: "190"
                                    },
                                    domProps: { value: _vm.cpassword },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.cpassword = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("font", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(_vm.frontendErrors.cpassword))
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                            _vm._v(" "),
                            _vm._m(19),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.changePassword()
                                      }
                                    }
                                  },
                                  [_vm._v("Save")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" })
                          ])
                        ])
                      ])
                    ]
                  )
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "firstName" } }, [
        _vm._v("First Name :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "lastName" } }, [
        _vm._v("Last Name :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "email" } }, [
        _vm._v("Email :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "username" } }, [
        _vm._v("Day Force Id :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "username" } }, [
        _vm._v("Reporting To :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "locationId" } }, [
        _vm._v("State :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "siteId" } }, [
        _vm._v("Home Location :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "siteId" } }, [
        _vm._v("Other Location :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "departmentId" } }, [
        _vm._v("Department :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "phone" } }, [
        _vm._v("Phone :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "post" } }, [
        _vm._v("Post :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c(
        "div",
        { staticClass: "form-label", attrs: { for: "teamdesignation" } },
        [_vm._v("Team Designation :")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "bio" } }, [
        _vm._v("Bio :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "roleId" } }, [
        _vm._v("Role :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "quote" } }, [
        _vm._v("Quote :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "phone" } }, [
        _vm._v("Quote Name :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "description" } }, [
        _vm._v("Description :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "drop1" } }, [
        _vm._v("Profile Picture :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Change Password")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            id: "changePasswordModel",
            "data-dismiss": "modal"
          }
        },
        [_vm._v("×")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04bbe8e7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04bbe8e7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/user/AddUpdateUsers.vue
// module id = null
// module chunks = 